<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FC4B4B" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center px-3>
      <v-flex
        xs12
        text-center
        style="background-color:#F8F8F8 ;font-family:sofiaPro;font-size:11px"
      >
        <v-btn :ripple="false" text style="text-transform:none"
          ><span style="color:#ACACAC">Primary Details </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:#ACACAC"> Services & Working Hours </span>
        </v-btn>
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:#ACACAC">Bank Details </span></v-btn
        >
        <v-btn :ripple="false" text style="text-transform:none">
          <span style="color:black;border-bottom:2px solid #3460E1">
            Documents
          </span>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 pt-10>
        <v-card>
          <v-layout wrap justify-center text-left py-5 pa-6>
            <v-flex xs12 text-center pt-3 pb-5>
              <span
                class="sofiaPro"
                style="
                  font-size: 20px;
                  padding-bottom: 8px;
                  border-bottom: 2px solid #0000001c;
                "
                >Upload Documents</span
              >
            </v-flex>
            <v-flex xs12>
              <v-card outlined tile height="200px">
                <v-layout wrap justify-center fill-height text-center>
                  <v-flex xs12 align-self-center>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-icon
                          large
                          color="#408BFF"
                          @click="$refs.files.click()"
                          >mdi-cloud-upload</v-icon
                        >
                      </v-flex>
                      <v-flex xs12>
                        <span class="sofiaPro">Upload Company Documents</span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          class="sofialight"
                          style="font-size: 12px; color: grey"
                          >Jpg or PDF</span
                        >
                      </v-flex>
                      <input
                        v-show="false"
                        id="file1"
                        ref="files"
                        type="file"
                        multiple
                        @change="browsedocs"
                      />
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 py-3>
              <v-chip
                v-for="(item, i) in docs"
                :key="i"
                class="ma-2"
                close
                color="red"
                text-color="white"
                @click:close="remove(i)"
              >
                {{ item.name }}
              </v-chip>
            </v-flex>
            <v-flex xs12>
              <v-btn dark block color="#E31E24" @click="adddocument">
                next
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      docs: [],
      docs1: [],
      docsdata: new FormData(),
      showSnackBar: false,
      msg: "",
      timeout: 3000,
      bankdata: {
        branch: null,
        accountHolder: null,
        accountNo: null,
        ifsc: null,
        bank: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 10 || "Max 10 digits",
      },
    };
  },
  //    computed: {
  //   bankdata() {
  //     if (this.bank) {
  //       return this.bank;
  //     } else return {};
  //   },
  // },
  methods: {
    adddocument() {
      for (var i = 0; i < this.docs.length; i++) {
        this.docsdata.append("documents", this.docs[i]);
      }

      axios({
        method: "post",
        url: "seller/profile/level4",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: this.docsdata,
      }).then((response) => {
        if (response.data.status) {
          this.msg = response.data.msg;
          this.showSnackBar = true;
          this.$emit("stepper", {
            level: 4,
          });
        } else {
          this.showSnackBar = true;
          this.msg = response.data.msg;
        }
        this.docsdata = new FormData();
        this.appLoading = false;
      });
    },
    browsedocs(event) {
      this.docs1 = event.target.files;
      if (this.docs.length < 3) {
        for (let i = 0; i < this.docs1.length; i++) {
          this.docs.push(this.docs1[i]);
        }
      }
      else {
        this.msg='Maximum 3 can be uploaded'
        this.showSnackBar=true
      }

      // console.log("docs issssss", this.docs);
    },
    remove(item) {
      console.log("item", item);
      this.docs.splice(item, 1);

      console.log("removed");
    },
  },
};
</script>
